import Swal from "sweetalert2";
import { formatCurrency } from "../../../../../shared/utils/formatCurrency";

import styles from "../../styles/addReceipt.module.css";

export function showAlertFavor(favor) {
  return Swal.mixin({
    icon: "warning",
    title: `El excedente de ₡${formatCurrency(
      favor,
    )} se ha aplicado como saldo a favor.`,
    background: "#2a3545",
    color: "#e5ecf5",
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}

export function showAlertErrorMonto() {
  return Swal.mixin({
    icon: "error",
    title: "No hay un monto definido aún",
    background: "#2a3545",
    color: "#e5ecf5",
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}

export function showRestanteError() {
  return Swal.mixin({
    icon: "error",
    title: "El total tiene que ser 0",
    background: "#2a3545",
    color: "#e5ecf5",
    customClass: {
      icon: styles.customIconWarning,
    },
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
      const progressBar = toast.querySelector(".swal2-timer-progress-bar");
      if (progressBar) {
        progressBar.style.backgroundColor = "#f97316";
      }
    },
  });
}
